export const ChartData =[
    {
        id:1,
        month:"January",
        Sale:200,
        Return:50
    },
    {
        id:2,
        month:"February",
        Sale:150,
        Return:105
    },
    {
        id:3,
        month:"March",
        Sale:60,
        Return:128
    },
    {
        id:4,
        month:"April",
        Sale:90,
        Return:52
    },
    {
        id:5,
        month:"May",
        Sale:90,
        Return:40
    },
    {
        id:6,
        month:"June",
        Sale:100,
        Return:10
    },
    {
        id:7,
        month:"July",
        Sale:200,
        Return:190
    },
    
    
    
    
]